import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class StaffService {
  httpClient = inject(HttpClient);
  constructor() {}

  getAllStaffs(): Observable<any> {
    let user: any = localStorage.getItem('user');
    let restaurant_id: any;
    if (user) {
      let jsonUser = JSON.parse(user);
      restaurant_id = jsonUser.restaurant_id;
    }
    return this.httpClient.get(ServiceConstant.apiUrl + `/business-users/get-all-users`).pipe(
      catchError((error) => {
        console.error('Get current restaurant all users:', error);
        return of(error);
      }),
    );
  }

  createNewStaff(staff: any): Observable<any> {
    return this.httpClient.post(ServiceConstant.apiUrl + `/business-users/register`, staff).pipe(
      catchError((error) => {
        console.error('Create New Staff:', error);
        return of(error);
      }),
    );
  }

  editStaff(staff: any, id: any): Observable<any> {
    return this.httpClient
      .patch(ServiceConstant.apiUrl + '/business-users/' + id + '/update-staff', staff)
      .pipe(
        catchError((error) => {
          console.error('edit existing staff:', error);
          return of(error);
        }),
      );
  }

  deleteStaff(userId: any): Observable<any> {
    return this.httpClient.delete<any>(ServiceConstant.apiUrl + '/business-users/' + userId).pipe(
      catchError((error) => {
        console.error('Error delete the user:', error);
        return of(error);
      }),
    );
  }

  suspendStaff(userId: any, staff: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/business-users/' + userId + '/suspend', staff)
      .pipe(
        catchError((error) => {
          console.error('Error suspend the user:', error);
          return of(error);
        }),
      );
  }

  unSuspendStaff(userId: any, staff: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/business-users/' + userId + '/unsuspend', staff)
      .pipe(
        catchError((error) => {
          console.error('Error suspend the user:', error);
          return of(error);
        }),
      );
  }

  setPinStaff(userId: any, pin: any): Observable<any> {
    return this.httpClient
      .patch<any>(ServiceConstant.apiUrl + '/business-users/' + userId + '/set-pin', pin)
      .pipe(
        catchError((error) => {
          console.error('Error set pin the user:', error);
          return of(error);
        }),
      );
  }

  viewPinStaff(userId: any): Observable<any> {
    return this.httpClient
      .get<any>(ServiceConstant.apiUrl + '/business-users/' + userId + '/pin')
      .pipe(
        catchError((error) => {
          console.error('Error view pin the user:', error);
          return of(error);
        }),
      );
  }
}
